module.exports = __webpack_public_path__ + "img/logo_header.4a8fd38.png";